import { Component, Input, OnInit } from '@angular/core';
import { RootService } from '@services/root.service';
import { CurrencyService } from '@services/currency.service';
import { CurrencyRateService } from '@services/currency-rate.service';
import { AuthenticationService } from '@app/_services/authentication.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { TranslateHelper } from '@app/_helpers';
import { Router, RouterLink } from '@angular/router';
import { NgIf } from '@angular/common';
import { DirectionService } from '@app/_services/direction.service';
import { MatIconModule } from '@angular/material/icon';
import { EventCollectorDirective } from '../../../_directives/events-collector/events.collector';
import { ClickDirective } from '../../directives/click.directive';
import { BidiModule } from '@angular/cdk/bidi';
import { RatingComponent } from '../rating/rating.component';
import { CurrencyConvertPipe } from '../../pipes/currency-convert.pipe';

@Component({
    selector: 'app-professional-card',
    templateUrl: './professional-card.component.html',
    styleUrls: ['./professional-card.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [BidiModule, ClickDirective, RouterLink, NgIf, EventCollectorDirective, MatIconModule, TranslateModule, RatingComponent, CurrencyConvertPipe]
})
export class ProfessionalCardComponent implements OnInit {
    constructor(
        public root: RootService,
        public direction: DirectionService,
        public currency: CurrencyService,
        public currencyRate: CurrencyRateService,
        private authenticationService: AuthenticationService,
        public translate: TranslateService,
        public translateHelper: TranslateHelper,
        private router: Router,
    ) { }

    @Input() professional: any;
    @Input() layout: 'grid-sm' | 'grid-nl' | 'grid-lg' | 'list' | 'horizontal' | null = null;

    image = 'assets/images/nologo.png';
    hasLogo = false;
    userDetails;

    ngOnInit(): void {

        this.userDetails = this.authenticationService.currentUserValue;

        this.image = 'assets/images/nologo.png';
        if (this.professional?.profession?.design?.logo) {
            this.image = this.professional?.profession.design.logo.url || 'assets/images/nologo.png';
            this.hasLogo = !!this.professional?.profession?.design?.logo;
        }
        this.image = this.image.replace(/\(/g, "%28").replace(/\)/g, "%29").replace(/\ /g, '%20').replace(/\'/g, '%27').replace(/\"/g, '%22');
    }

    get professionalName() {
        return this.translateHelper.localize(this.professional?.profession?.title || { en: this.professional.name, ar: this.professional.name });
    }

    routerLinkString() {
        return [`/${this.translate.currentLang}`, 'professional', this.professional?.profession?.seo?.slug];
    }

    get locationLabel(): string {
        const address = this.professional?.profession?.address;
        return [address?.country, address?.city].filter((part) => !!part).join(', ');
    }

    get initials(): string {
        const name: string = this.professional?.name || '';
        const parts = name.trim().split(/\s+/).filter((part: string) => !!part);
        return parts.slice(0, 2).map((part: string) => part.charAt(0).toUpperCase()).join('');
    }

    get contactPhone(): string {
        return this.professional?.profession?.address?.phone || this.professional?.phone || '';
    }

}
